// @flow
import React, { Component } from 'react';
import queryString from 'query-string';
import { CommonActions } from 'store/actionCreators';
import type { State } from 'store';
import { connect } from 'react-redux';
import CategoryCurrent from 'components/categories/CategoryCurrent/CategoryCurrent';
import CategorySubItem from 'components/categories/CategorySubItem';
import CategorySupplierItem from 'components/categories/CategorySupplierItem';

import { type CategoryData } from 'store/modules/common';
import { type ContextRouter, withRouter } from 'react-router-dom';

import './CategoryCurrentContainer.scss';
import CategoryBreadcrumbs from '../../components/categories/CategoryBreadcrumbs/CategoryBreadcrumbs';

type OwnProps = {
  category: string,
};

type Props = OwnProps & {
  selected: ?CategoryData,
} & ContextRouter;

class CategoryCurrentContainer extends Component<Props> {
  initialize = async () => {
    const { category, history, location } = this.props;
    const supplier = queryString.parse(this.props.location.search).supplier || '';
    try {
      await CommonActions.getCategoryInfo(category);
    } catch (e) {
      console.log(e);
      if (e && e.response && e.response.status === 404) {
        history.replace('/404');
      }
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category || prevProps.location !== this.props.location) {
      this.initialize();
    }
  }

  componentWillUnmount() {
    CommonActions.setCategoryInfo(null);
  }

  render() {
    const { selected, categories } = this.props;

    return (
      <div className="CategoryCurrentContainer">
        {categories && selected && (
          <CategoryBreadcrumbs allCategories={categories} selectedCategory={selected} />
        )}
        <CategoryCurrent
          name={selected && selected.name}
          count={selected && selected.products_count}
        />
        {selected && selected.order === 2 && selected.parent && selected.parent.length > 0 && (
          <div>
            <h3>카테고리</h3>
            <div className="box-category">
              {selected.parent.map(doc => (
                <CategorySubItem key={doc.id} name={doc.name} count={doc.products_count} />
              ))}
            </div>
          </div>
        )}
        {selected && selected.products_supplier && selected.products_supplier.length > 0 && (
          <div>
            <h3>브랜드</h3>
            <div className="box-supplier">
              {selected.products_supplier.map((doc, idx) => (
                <CategorySupplierItem
                  // eslint-disable-next-line react/no-array-index-key
                  key={idx}
                  category={selected.name}
                  supplier={doc.supplier}
                  count={doc.count}
                  location={this.props.location}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  ({ common }: State) => ({
    categories: common.categories.data,
    selected: common.categories.selected,
  }),
  () => ({}),
)(withRouter(CategoryCurrentContainer));



// WEBPACK FOOTER //
// ./src/containers/categories/CategoryCurrentContainer.js